const umlautMap = {
  "\u00dc": "UE",
  "\u00c4": "AE",
  "\u00d6": "OE",
  "\u00fc": "ue",
  "\u00e4": "ae",
  "\u00f6": "oe",
  "\u00df": "ss",
};

const MAX_EMAIL_LENGTH = 254;
const MAX_EMAIL_LOCAL_PART_LENGTH = 64;
const MAX_DOMAIN_LABEL_LENGTH = 63;
const EMAIL_LOCAL_PART_ALLOWED_CHARS = new Set("abcdefghijklmnopqrstuvwxyz0123456789!#$%&'*+/=?^_`{|}~.-");
const EMAIL_DOMAIN_LABEL_ALLOWED_CHARS = new Set("abcdefghijklmnopqrstuvwxyz0123456789-");

function replaceUmlauts(str: string) {
  return str
    .replace(/[\u00dc\u00c4\u00d6][a-z]/g, (a) => {
      const big = umlautMap[a.slice(0, 1)];
      return big.charAt(0) + big.charAt(1).toLowerCase() + a.slice(1);
    })
    .replace(new RegExp("[" + Object.keys(umlautMap).join("|") + "]", "g"), (a) => umlautMap[a]);
}

const hasOnlyAllowedChars = (value: string, allowedChars: Set<string>) => {
  for (const char of value) {
    if (!allowedChars.has(char)) {
      return false;
    }
  }
  return true;
};

const isValidEmailLocalPart = (localPart: string) => {
  if (!localPart || localPart.length > MAX_EMAIL_LOCAL_PART_LENGTH) {
    return false;
  }

  if (localPart.startsWith(".") || localPart.endsWith(".") || localPart.includes("..")) {
    return false;
  }

  return hasOnlyAllowedChars(localPart, EMAIL_LOCAL_PART_ALLOWED_CHARS);
};

const isValidEmailDomainLabel = (label: string) => {
  if (!label || label.length > MAX_DOMAIN_LABEL_LENGTH) {
    return false;
  }

  if (label.startsWith("-") || label.endsWith("-")) {
    return false;
  }

  return hasOnlyAllowedChars(label, EMAIL_DOMAIN_LABEL_ALLOWED_CHARS);
};

const isValidEmailDomain = (domain: string) => {
  const labels = domain.split(".");

  if (labels.length < 2) {
    return false;
  }

  return labels.every(isValidEmailDomainLabel);
};

/**
 * returns "true" if email is VALID.
 * @param uid - string that is received from back-end that represents ID of record or plain email.
 */
export function validateEmail(uid: string) {
  if (!uid) {
    return false;
  }

  if (uid.length > MAX_EMAIL_LENGTH) {
    return false;
  }

  const withoutUmlauts = replaceUmlauts(uid.toLowerCase());
  const atIndex = withoutUmlauts.indexOf("@");

  if (atIndex === -1 || atIndex !== withoutUmlauts.lastIndexOf("@")) {
    return false;
  }

  const localPart = withoutUmlauts.slice(0, atIndex);
  const domain = withoutUmlauts.slice(atIndex + 1);

  return isValidEmailLocalPart(localPart) && isValidEmailDomain(domain);
}

/**
 * returns "true" if email is VALID or UID is valid.
 * @param uid - string that is received from back-end that represents ID of record or plain email.
 */
export function validateEmailOrUid(uid: string) {
  if (uid.startsWith("@user") || uid.startsWith("@contact") || uid.startsWith("@group")) {
    return true;
  }
  return validateEmail(uid);
}
